import { Flex } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

import { useGlobalSpecialsModal } from '@jane/business-admin/providers/GlobalSpecialsModalProvider';

export const SpendingThreshold = () => {
  const { isDisabled } = useGlobalSpecialsModal();

  return (
    <Flex
      justifyContent="space-between"
      width="100%"
      gap={24}
      flexDirection="column"
    >
      <Flex width="100%" gap={24} mb={24}>
        <Form.NumberField
          width="100%"
          name="display.spending_threshold.max_applications_per_cart"
          label="Maximum uses per order"
          disabled={isDisabled}
          min={1}
          disableOnWheel
        />
      </Flex>
    </Flex>
  );
};
